import { ChangeEvent, FC, useEffect, useState } from 'react';
import { DropdownButton, InputGroup } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import Routes from '../../constants/routes';
import options from '../../constants/world-switch';
import { ReactComponent as ExpandMoreIcon } from '../../images/expand_more.svg';
import { ReactComponent as WorldIcon } from '../../images/language.svg';
import translation, { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import qualityEvents from '../../services/quality-events';
import RadioButton from '../radio-button/radio-button';
import MarketplaceSuggestion from './components/marketplace-suggestion/marketplace-suggestion';
import './world-switch.scss';

const processedConfig = () => {
    const array = [...options];
    const selectedOptionIndex = array.findIndex((el) => el.code === world);

    if (selectedOptionIndex >= 1) {
        const primaryOption = array.splice(selectedOptionIndex, 1);

        array.unshift(primaryOption[0]);
    }

    return array;
};

const config = processedConfig();

type WorldSwitchProps = TranslationProps & {
    asIcon?: boolean;
};

const WorldSwitch: FC<WorldSwitchProps> = ({ asIcon, t }) => {
    // @ts-ignore
    const selectedWorldTitle = config.find((item) => item.code === world)?.title || '';
    const [selectedWorld, setSelectedWorld] = useState(world);
    const [searchValue, setSearchValue] = useState('');
    const [worldOptions, setWorldOptions] = useState(config);

    useEffect(() => {
        const filtered = config.filter(
            (option) =>
                `${option.title}`.toLowerCase().includes(searchValue.toLowerCase()) ||
                `${option.name}`.toLowerCase().includes(searchValue.toLowerCase())
        );

        setWorldOptions(filtered);
    }, [searchValue]);

    const detectSwitchableRoute = (selectedWorld: AVAILABLE_WORLDS) => {
        const keys = Object.keys(Routes);
        let url = '';

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            if (Routes[key].path === window.location.pathname) {
                if (Routes[key].pathnames && Routes[key].switchable) {
                    url = Routes[key].pathnames[selectedWorld];
                }

                break;
            }
        }

        return url;
    };

    // @ts-ignore
    const onSelect = (selectedWorld: AVAILABLE_WORLDS, e) => {
        e.preventDefault();
        e.stopPropagation();

        setSelectedWorld(selectedWorld);

        const url = detectSwitchableRoute(selectedWorld) || `/${selectedWorld}`;
        const extra = {
            type: asIcon ? 'icon' : 'button',
            world,
            selectedWorld
        };

        qualityEvents.track({
            extra: JSON.stringify(extra),
            type: 'toggleWorldSwitch'
        });

        setTimeout(() => {
            window.locationReload(url);
        }, 300);
    };

    const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    const dropdownContent = () => {
        return (
            <>
                <InputGroup>
                    <input
                        onChange={onSearch}
                        className='form-control tsc-body'
                        defaultValue=''
                        placeholder={t('common.worldSwitch.inputPlaceholder')}
                        type='text'
                    />
                </InputGroup>
                <div className='options'>
                    {worldOptions
                        // @ts-ignore
                        .filter((code) => code !== world)
                        .map(({ code, title }) => {
                            return (
                                <div key={code} onClick={(e) => onSelect(code, e)}>
                                    <RadioButton
                                        checked={code === selectedWorld}
                                        id={`world-item-${code}`}
                                        label={title}
                                        key={code + selectedWorld ? selectedWorld : ''}
                                    />
                                </div>
                            );
                        })}
                </div>
                <MarketplaceSuggestion />
            </>
        );
    };

    return (
        <div className='world-switch d-flex align-items-center'>
            {asIcon ? (
                <DropdownButton
                    menuAlign='right'
                    title={<WorldIcon height={21} />}
                    className='as-icon'
                    variant='default'
                >
                    {dropdownContent()}
                </DropdownButton>
            ) : (
                <>
                    <WorldIcon />
                    <DropdownButton
                        menuAlign='right'
                        title={
                            <span className='selected-world'>
                                {selectedWorldTitle} <ExpandMoreIcon />
                            </span>
                        }
                        variant='default'
                    >
                        {dropdownContent()}
                    </DropdownButton>
                </>
            )}
        </div>
    );

    // return (
    //     <div className='world-switch d-flex align-items-center'>

    //     </div>
    // );
};

const translate = translation(['common']);

export default withRouter(translate(WorldSwitch));
